var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('profile-update-form',{on:{"updated":_vm.openMessageNotifier}}),_c('password-update-form',{on:{"updated":_vm.openMessageNotifier}}),_c('message-notifier',{ref:"notifier"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }